/**
 * Screen labels use glyphs a CAD font does not carry: the angle sign, arrows, the middle dot.
 * A TEXT value in the file keeps to Cyrillic, Latin, digits and the DXF control code `%%d` for
 * the degree sign, so AutoCAD, BricsCAD, LibreCAD and QCAD all show it with their own fonts.
 */

/** The DXF control code AutoCAD and its readers draw as the degree sign. */
export const DXF_DEGREE: string = '%%d';

/** A label in the file's alphabet: the replacements first, then a line break folded into a space. */
export function toDxfText(text: string): string {
    const angleWord: string = $localize`:@@legendAngle:Угол`.toLowerCase();
    return (
        text
            // `∠ 38.5°` reads «угол 38.5°».
            .replace(/∠\s*/g, `${angleWord} `)
            // An arrow beside a word is a pointer the drawing shows with its own line; the word stays.
            .replace(/[←↑→↓]/g, ' ')
            .replace(/·/g, ',')
            .replace(/×/g, 'x')
            .replace(/[–—]/g, '-')
            .replace(/≈/g, '~')
            .replace(/≤/g, '<=')
            .replace(/≥/g, '>=')
            .replace(/°/g, DXF_DEGREE)
            // A line break would end the group value early; a label is one line.
            .replace(/[\r\n]+/g, ' ')
            .replace(/ {2,}/g, ' ')
            .replaceAll(' ,', ',')
            .trim()
    );
}
